module.exports = __webpack_public_path__ + "static/img/test-bg-2.23422fee.png";